import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .filter('frequencyDisplay', function (PeriodicTasksService) {
            return function (repeaterConfig) {
                return PeriodicTasksService.frequencyDisplay(
                    repeaterConfig.frequency,
                    repeaterConfig.interval
                );
            };
        })
        .controller('TaskListController', TaskListController);

    function TaskListController($state, PeriodicTasksFactory) {
        var vm = this;

        init();

        vm.handleRowClick = function (taskId) {
            $state.go('company_employee.periodic_tasks.task_list.task_details', {
                id: taskId,
            });
        };

        function init() {
            vm.taskList = [];

            PeriodicTasksFactory.read().then(function (response) {
                vm.taskList = response.data;
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/periodic_tasks/task_list/task_list.controller.ts